import type { PropsWithChildren } from "react"
import type { RenderHostAppLink } from "../types/hostAppLink"
import { cn } from "../utils/cn"
import styles from "@src/components/Wallet/VeaxButton.module.css"

interface AuthGateProps extends PropsWithChildren {
  renderHostAppLink: RenderHostAppLink
  shouldRender: boolean
  className?: string
}

export function AuthGate({
  renderHostAppLink,
  shouldRender,
  className,
  children,
}: AuthGateProps) {
  return shouldRender
    ? (children ?? null)
    : renderHostAppLink(
        "sign-in",
        <button type="button" className={cn(styles.veaxButton, styles.primary, styles.large, styles.fullWidth, className)}>
          <span className={styles.content}>CONNECT WALLET</span>
        </button>,
        { className: "w-full" }
      )
}
